/**
 * LE DÉNICHEUR — Tiroir panier.
 *
 * - L'icône panier du header (#ldCartToggle) ouvre le tiroir au lieu d'aller sur /cart.
 * - Les formulaires d'ajout au panier (/cart/add) passent par l'API AJAX puis ouvrent le tiroir
 *   (bouton principal et barre collante de la fiche produit, qui soumettent le même formulaire).
 * - Quantités et suppression via /cart/change.js ; le contenu est re-rendu par le Section
 *   Rendering API (section « ld-cart-drawer »), donc toute la mise en forme reste en Liquid.
 * Sans ce script, ou sur la page /cart, tout garde le comportement natif.
 */
(function () {
  'use strict';

  var SECTION_ID = 'ld-cart-drawer';
  var drawer = document.getElementById('LdCartDrawer');
  var onCartPage = document.querySelector('main[data-template="cart"]') !== null;
  if (!drawer || onCartPage || !window.fetch) return;

  var panel = drawer.querySelector('.ld-cd__panel');
  var lastFocus = null;
  var busy = false;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* ── Ouverture / fermeture ── */
  function open() {
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('ld-cd-lock');
    setTimeout(function () { panel.focus(); }, 50);
  }

  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('ld-cd-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  drawer.addEventListener('click', function (e) {
    if (e.target.closest('[data-ld-cd-close]')) close();
  });

  document.addEventListener('keydown', function (e) {
    if (!drawer.classList.contains('is-open')) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var focusables = panel.querySelectorAll('a[href], button:not([disabled]), input, [tabindex="0"]');
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
      e.preventDefault(); last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault(); first.focus();
    }
  });

  /* ── Rendu ── */
  function render(sections) {
    var html = sections && sections[SECTION_ID];
    if (!html) return false;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-ld-cd-content]');
    var current = drawer.querySelector('[data-ld-cd-content]');
    if (!fresh || !current) return false;
    current.replaceWith(fresh);
    updateCount(parseInt(fresh.getAttribute('data-count'), 10) || 0);
    return true;
  }

  function updateCount(count) {
    var badge = document.getElementById('ldCartCount');
    if (!badge) return;
    badge.textContent = count;
    badge.classList.toggle('has-items', count > 0);
  }

  function showError(message) {
    var el = drawer.querySelector('[data-ld-cd-error]');
    if (!el) return;
    el.textContent = message;
    el.hidden = !message;
  }

  function refresh() {
    return fetch(root() + '?sections=' + SECTION_ID, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(render);
  }

  /* ── Icône panier ── */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('#ldCartToggle');
    if (!toggle || e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault();
    open();
    refresh().catch(function () {});
  });

  /* ── Ajout au panier ── */
  function nativeSubmit(form) {
    form.setAttribute('data-ld-cd-skip', '');
    HTMLFormElement.prototype.submit.call(form);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    var action = form.getAttribute('action') || '';
    if (!/\/cart\/add\/?$/.test(action) || form.hasAttribute('data-ld-cd-skip')) return;
    e.preventDefault();
    if (busy) return;

    var buttons = [];
    try {
      busy = true;
      /* Attention : form.id renverrait le champ <input name="id"> de la variante */
      var formId = form.getAttribute('id');
      buttons = Array.prototype.slice.call(form.querySelectorAll('button[type="submit"]'));
      if (formId) {
        buttons = buttons.concat(Array.prototype.slice.call(document.querySelectorAll('button[type="submit"][form="' + formId.replace(/"/g, '') + '"]')));
      }
      buttons.forEach(function (b) { b.setAttribute('aria-busy', 'true'); b.classList.add('is-loading'); });

      var data = new FormData(form);
      data.append('sections', SECTION_ID);
      data.append('sections_url', window.location.pathname);
    } catch (err) {
      busy = false;
      nativeSubmit(form);
      return;
    }

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: data
    })
      .then(function (r) { return r.json().then(function (json) { return { ok: r.ok, json: json }; }); })
      .then(function (res) {
        if (!res.ok) {
          return refresh().then(function () {
            showError(res.json.description || res.json.message || "Impossible d'ajouter ce produit.");
            open();
          });
        }
        if (!render(res.json.sections)) return refresh().then(open);
        showError('');
        open();
      })
      .catch(function () {
        /* En cas d'échec, on retombe sur le comportement natif (page /cart) */
        nativeSubmit(form);
      })
      .finally(function () {
        busy = false;
        buttons.forEach(function (b) { b.removeAttribute('aria-busy'); b.classList.remove('is-loading'); });
      });
  });

  /* ── Quantités / suppression ── */
  drawer.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ld-cd-qty]');
    if (!btn || busy) return;
    var item = btn.closest('[data-key]');
    if (!item) return;
    busy = true;
    item.classList.add('is-updating');

    fetch(root() + 'cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id: item.getAttribute('data-key'),
        quantity: parseInt(btn.getAttribute('data-ld-cd-qty'), 10),
        sections: [SECTION_ID],
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json().then(function (json) { return { ok: r.ok, json: json }; }); })
      .then(function (res) {
        if (!res.ok) {
          return refresh().then(function () {
            showError(res.json.description || res.json.message || 'Quantité indisponible.');
          });
        }
        render(res.json.sections);
        showError('');
      })
      .catch(function () { showError('Une erreur est survenue, merci de réessayer.'); })
      .finally(function () {
        busy = false;
        item.classList.remove('is-updating');
      });
  });

  /* ── Suggestions : ajout en un clic ── */
  drawer.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ld-cd-add]');
    if (!btn || busy) return;
    busy = true;
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: parseInt(btn.getAttribute('data-ld-cd-add'), 10), quantity: 1 }],
        sections: [SECTION_ID],
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json().then(function (json) { return { ok: r.ok, json: json }; }); })
      .then(function (res) {
        if (!res.ok) {
          return refresh().then(function () {
            showError(res.json.description || res.json.message || "Impossible d'ajouter ce produit.");
          });
        }
        if (!render(res.json.sections)) return refresh();
        showError('');
        var body = drawer.querySelector('.ld-cd__body');
        if (body) body.scrollTop = 0;
      })
      .catch(function () { showError('Une erreur est survenue, merci de réessayer.'); })
      .finally(function () {
        busy = false;
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
      });
  });

  /* Ouvrir le tiroir depuis ailleurs : window.ldCartDrawer.open() */
  window.ldCartDrawer = { open: function () { open(); refresh().catch(function () {}); }, close: close, refresh: refresh };
})();
